import { Component, OnInit } from '@angular/core';

import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-manual-reflect-data',
  templateUrl: './manual-reflect-data.component.html',
  styleUrls: ['./manual-reflect-data.component.css'],
  standalone: false,
})
export class ManualReflectDataComponent implements OnInit {

  readonly manualTopLink: string = AppConst.ROUTING_LINK_MANUAL_INDEX;
  readonly facilityLink: string = AppConst.ROUTING_LINK_MANUAL_FACILITY;

  currentLang: string = 'ja';

  constructor(
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.currentLang = this.translate.currentLang;
  }

}
